<template lang="pug">
  tbody
    tr
      th(colspan=2) {{ lotto_title }}
      td
        PTSelect(
          ref="lotto_upline_pt"
          :dirty="$v.lotto_upline_pt.$dirty"
          :error="$v.lotto_upline_pt.$error"
          :options="lotto_upline_options"
          :value="lotto_upline_pt"
          @input="input_lotto_upline_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="lotto_account_pt"
          :dirty="$v.lotto_account_pt.$dirty"
          :error="$v.lotto_account_pt.$error"
          :options="lotto_account_options"
          :value="lotto_account_pt"
          @input="input_lotto_account_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="lotto_upline_remaining"
          :dirty="$v.lotto_upline_remaining.$dirty"
          :error="$v.lotto_upline_remaining.$error"
          :options="lotto_account_options"
          :value="lotto_upline_remaining"
          @input="$v.lotto_upline_remaining.$model = $event"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="lotto_account_min"
          :dirty="$v.lotto_account_min.$dirty"
          :error="$v.lotto_account_min.$error"
          :options="lotto_min_options"
          :value="lotto_account_min"
          @input="$v.lotto_account_min.$model = $event"
          :disabled="loading"
        )
</template>

<script>
import { required, minValue } from "vuelidate/lib/validators";
import PTSelect from "@/library/PTSelect";

export default {
  components: {
    PTSelect
  },
  props: {
    loading: false,
    accountID: ""
  },
  data() {
    return {
      lotto_upline_pt: 0,
      lotto_account_pt: 0,
      lotto_upline_remaining: 0,
      lotto_account_min: 0
    }
  },
  validations() {
      return {
      lotto_upline_pt: {
        required,
        minValue(value) {
          if(this.$helpers.isPlatformEnabled('LO')) {
            let total = 0
            if(this.$helpers.isAgentLevel()) {
              total = value
            } else {
              total = value + this.lotto_account_pt
            }
            if(total < this.lotto_upline_min) {
              return false
            } else {
              return true
            }
          } else {
            return true
          }
        }
      },
      lotto_account_pt: {
        required,
        minValue(value) {
          if(this.$helpers.isPlatformEnabled('LO')) {
            let total = 0
            if(this.$helpers.isAgentLevel()) {
              return true
            } else {
              total = value + this.lotto_upline_pt
              if(total < this.lotto_upline_min) {
                return false
              } else {
                return true
              }
            }
          } else {
            return true
          }
        }
      },
      lotto_upline_remaining: {
        required
      },
      lotto_account_min: {
        required
      }
    }
  },
  computed: {
    isSearch: function() {
      if(this.accountID) {
        return !(this.accountID.length > 8)
      } else {
        return !this.$helpers.isAgentLevel()
      }
    },
    lotto_title: function () {
      return this.$t("ui.lotto") + " (" + this.lotto_upline_min + "%-" + this.lotto_upline_max + "%)"
    },
    lotto_upline_min: function() {
      return this.$store.getters.getPTLO[0].account_min
    },
    lotto_upline_max: function() {
      return this.$store.getters.getPTLO[0].account_pt
    },
    lotto_account_max: function() {
      return this.lotto_upline_max - this.lotto_upline_pt
    },
    lotto_upline_options: function() {
      return this.$helpers.getPTRateList(this.lotto_upline_max)
    },
    lotto_account_options: function() {
      return this.$helpers.getPTRateList(this.lotto_account_max)
    },
    lotto_min_options: function() {
      return this.$helpers.getPTRateList(this.lotto_account_pt)
    }
  },
  mounted: function() {
    if(this.$helpers.isAgentLevel()) {
      this.$v.lotto_upline_pt.$model = this.lotto_upline_max
    }
    if(!this.$helpers.isPlatformEnabled('LO')) {
      this.$v.lotto_upline_pt.$model = this.lotto_upline_min
    }
  },
  methods: {
    input_lotto_upline_pt(e) {
      this.$v.lotto_upline_pt.$model = e
      this.$v.lotto_account_pt.$model = this.lotto_account_max

      if (this.lotto_upline_remaining > this.lotto_account_max) {
        this.$v.lotto_upline_remaining.$model = 0
      }
      if (this.lotto_account_min > this.lotto_account_pt) {
        this.$v.lotto_account_min.$model = 0
      }
    },
    input_lotto_account_pt(e) {
      this.$v.lotto_account_pt.$model = e
      if (this.lotto_account_min > this.lotto_account_pt) {
        this.$v.lotto_account_min.$model = 0
      }
    }
  }
}

</script>